import React from 'react'
import { useHistory } from 'react-router-dom'

function Bricoleurs() {
  let { location } = useHistory()
  return (
    <div
      style={{
        color: `${location.pathname === '/bricoleurs' ? '#2ACC96' : 'white'}`,
      }}
    >
      Bricoleurs
    </div>
  )
}

export default Bricoleurs
